// Neutral animation data
// Imported from assets/lottie_files/guy_cycling_fast.json
import neutralAnimationData from "@lottiefiles/guy_cycling_fast.json" with { type: "json" };

export default neutralAnimationData;
